const fr = {
  nav: {
    home: "Accueil",
    about: "À propos",
    destinations: "Destinations",
    tours: "Circuits & Forfaits",
    gallery: "Galerie",
    testimonials: "Témoignages",
    blog: "Blog",
    contact: "Contactez-nous",
    experiences: "Expériences",
    vip: "VIP Affaires",
    vipFull: "Voyage VIP Affaires",
    worldcup: "Coupe du Monde 2030",
    menu: "Menu",
    chatWhatsApp: "Discuter sur WhatsApp",
    jewishHeritage: "Voyage Casher"
  },
  hero: {
    welcome: "Bienvenue au Maroc.",
    welcomeHome: "Bienvenue chez vous.",
    subtitle: "Circuits privés de luxe, expériences authentiques,",
    subtitleLine2: "et service personnalisé complet à travers le Maroc —",
    subtitleGold: "géré personnellement par le PDG.",
    whatsappBtn: "Discutez avec Ilan (PDG) maintenant sur WhatsApp",
    badgeFast: "Réponse rapide",
    badgePersonal: "Service personnalisé",
    badge247: "Disponibilité 24h/24",
    limitedAvail: "Disponibilité limitée",
    personalizedOnly: "Voyages personnalisés uniquement"
  },
  strip: {
    privateTours: "Circuits Privés",
    localExperts: "Experts Locaux",
    bestHotels: "Meilleurs Hôtels",
    luxuryTransport: "Transport de Luxe",
    satisfaction: "100% Satisfaction"
  },
  cta: {
    whatsapp: "Discutez avec Ilan (PDG) maintenant sur WhatsApp",
    whatsappFloating: "Discuter sur WhatsApp",
    whatsappInquiry: "Bonjour, je suis intéressé par une expérience de voyage premium au Maroc."
  },
  home: {
    vipBannerTitle: "Expériences VIP au Maroc",
    vipBannerText: "Accès exclusif, chauffeurs privés et hébergements de luxe pour les voyageurs exigeants.",
    vipBannerBtn: "Découvrir les Services VIP",
    wcBadge: "🇲🇦 Coupe du Monde Maroc 2030",
    wcTitle: "Maroc 2030",
    wcText: "Forfaits exclusifs pour la Coupe du Monde combinant football, culture marocaine, hospitalité VIP et expériences de luxe.",
    wcBtn: "Voir les Forfaits",
    galleryTitle: "Galerie",
    gallerySubtitle: "Un aperçu de votre futur voyage au Maroc",
    exploreDestination: "Explorer la destination",
    featuredToursTitle: "Circuits & Forfaits en Vedette",
    featuredToursSubtitle: "Des expériences soigneusement sélectionnées pour l'aventure marocaine parfaite",
    viewAllTours: "Voir Tous les Circuits",
    culinaryTitle: "Notre Cuisine - La Meilleure au Monde",
    culinarySubtitle: "Découvrez l'excellence culinaire marocaine 🍲",
    culinaryBtn: "Découvrir les Expériences Culinaires",
    culinaryIntro: "Chez Morocco Loves You, manger n'est pas seulement se nourrir. C'est un voyage au cœur de la culture marocaine. Nous proposons des expériences culinaires authentiques et triées sur le volet — des repas traditionnels faits maison à la haute gastronomie marocaine, le tout préparé avec amour et les ingrédients locaux les plus frais.",
    videoTitle: "RECOMMANDATIONS",
    unityQuote: "Morocco Loves You accueille toutes les cultures, toutes les croyances et tous les peuples.",
    unityAlt: "Bannière d'unité Morocco Loves You",
    testimonialsTitle: "Ce que Disent nos Invités VIP",
    testimonialsSubtitle: "Vrais avis de voyageurs internationaux",
    readMoreReviews: "Lire Plus d'Avis",
    viewAllTransport: "Voir Tous les Transports",
    transportTitle: "Nos Chauffeurs & Transports VIP",
    transportSubtitle: "Luxe, Confort & Sécurité à Travers le Maroc 🌍",
    transportIntro: "Chez Morocco Loves You, le transport ne consiste pas seulement à se déplacer d'un endroit à un autre. Cela fait partie de l'expérience. Nous fournissons des véhicules modernes, propres, confortables et entièrement climatisés dans tout le Maroc — avec des chauffeurs professionnels, une hospitalité chaleureuse et un service VIP dès le premier instant."
  },
  tours: {
    pageTitle: "Circuits & Forfaits",
    pageSubtitle: "Choisissez parmi nos forfaits de voyage soigneusement sélectionnés",
    sectionTitle: "Nos Forfaits",
    sectionIntro: "Des aventures dans le désert aux escapades côtières, nous avons le forfait parfait pour chaque voyageur",
    howToBook: "Comment Réserver",
    step1Title: "Choisissez un Circuit",
    step1Text: "Parcourez nos forfaits et sélectionnez celui qui vous convient le mieux",
    step2Title: "Cliquez Réserver",
    step2Text: "Cliquez sur le bouton \"Réserver\" de votre circuit choisi",
    step3Title: "Remplissez les Détails",
    step3Text: "Fournissez vos dates de voyage et informations personnelles",
    step4Title: "Confirmation",
    step4Text: "Recevez la confirmation et les détails de l'itinéraire par e-mail",
    customTitle: "Besoin d'un Forfait Personnalisé ?",
    customText: "Contactez-nous pour créer une expérience marocaine sur mesure",
    customBtn: "Nous Contacter",
    days: "Jours",
    highlights: "Points forts :",
    bookNow: "Réserver Maintenant",
    highlightsLabel: "POINTS FORTS :",
    viewFullDetails: "Voir les Détails Complets",
    viewDetails: "Voir les Détails",
    premiumPackage: "Forfait Premium",
    arrival: "Arrivée :",
    route: "Itinéraire :",
    flights: "Vols :",
    transportation: "Transport :",
    hotels: "Hôtels :",
    foodDining: "Restauration :",
    whatsIncluded: "Ce Qui Est Inclus :",
    attractionsExperiences: "Attractions & Expériences :",
    specialSaharaExperience: "Expérience Spéciale Sahara :",
    suitableFor: "Convient Pour :",
    importantNotes: "Remarques Importantes :",
    priceInformation: "Informations sur les Prix :",
    priceWarningText: "Les prix peuvent changer en fonction du prix des vols, des taux de change, des vacances, des saisons et de la disponibilité des hôtels.",
    safetyComfort: "Sécurité & Confort :",
    safetyText: "Nous travaillons en coordination avec les autorités marocaines et les services de sécurité pour assurer la sécurité et le confort de nos clients.",
    safetyTextBrief: "Coordonné avec les autorités marocaines pour votre sécurité.",
    givesMore: "Morocco Loves You en donne plus :",
    givesMoreText: "Plus d'amour, d'attention, de professionnalisme, de joie et de sécurité. Des circuits faciles et relaxants avec une véritable hospitalité humaine.",
    givesMoreBrief: "Morocco Loves You :",
    givesMoreTextBrief: "Plus d'amour, d'attention et de professionnalisme.",
    bookThisPackage: "Réserver ce Forfait",
    backToPackages: "Retour aux Forfaits",
    premiumMoroccoPackages: "Forfaits Premium Maroc",
    premiumMoroccoPackagesDesc: "Des expériences exclusives et soigneusement sélectionnées pour nos clients exigeants.",
    suitable: {
      couples: "Couples",
      families: "Familles",
      groups: "Groupes",
      solo: "Voyageurs solo",
      seniors: "Seniors",
      companies: "Entreprises",
      agencies: "Agences de voyages",
      operators: "Tour-opérateurs"
    },
    pkg1: {
      title: "Échappée de Luxe le Week-end à Fès",
      duration: "3 Nuits / 4 Jours (Jeudi → Dimanche)",
      price: "790 €",
      hl1: "Vols directs aller-retour inclus (Londres/Europe)",
      hl2: "Hôtels de luxe 4–5 étoiles",
      hl3: "Hammam marocain traditionnel",
      hl4: "Ateliers de cuisine et d'art",
      hl5: "Spectacles marocains en direct",
      hl1_brief: "Vols directs aller-retour inclus",
      subtitle: "Forfait Tout Inclus – De A à Z",
      flight1: "Vols directs aller-retour",
      flight2: "Bagage enregistré de 20 kg",
      flight3: "Bagage cabine jusqu'à 8 kg",
      inc1: "Accueil à l'aéroport et transfert de retour",
      inc2: "Hôtels 4–5 étoiles (Demi-pension)",
      inc3: "Cuisine marocaine fraîche et authentique",
      inc4: "Expérience de thé et pâtisseries traditionnelles",
      inc5: "Guide touristique professionnel & Chauffeur privé",
      inc6: "Transport moderne climatisé",
      inc7: "Spectacles spéciaux en direct (Chanteurs & danseurs)",
      inc7_brief: "Spectacles spéciaux en direct",
      inc8: "Visites des marchés traditionnels (Épices, Lanternes, Tapis)",
      inc8_brief: "Visites des marchés traditionnels",
      inc9: "Ateliers de cuisine et d'art (Réservation préalable requise)",
      inc9_brief: "Ateliers de cuisine et d'art",
      inc10: "Visites de sources naturelles et de belvédères",
      inc11: "Excursions d'une journée à Chefchaouen & Ifrane",
      inc12: "Visites chez des familles marocaines locales",
      inc13: "Expériences surprises pendant le circuit",
      suit1: "Couples",
      suit2: "Familles",
      suit3: "Groupes",
      suit4: "Voyageurs solo",
      suit5: "Seniors",
      suit6: "Entreprises",
      suit7: "Agences de voyages",
      suit8: "Tour-opérateurs"
    },
    pkg2: {
      title: "Circuit Découverte de Luxe au Maroc",
      duration: "6 Nuits / 7 Jours (Lundi → Dimanche)",
      price: "1490 €",
      hl1: "Route de Fès & Nord du Maroc",
      hl2: "Visites de Chefchaouen & Tanger",
      hl3: "Vols directs & chauffeur privé",
      hl4: "Emplacements premium & service haut de gamme",
      hl5: "Hospitalité marocaine authentique",
      subtitle: "Route de Fès & Nord du Maroc (Tout Inclus)",
      routeText: "2 nuits à Fès, 1 nuit à Chefchaouen, 1 nuit à Tanger, 1 nuit à Ifrane, 1 dernière nuit à Fès",
      flight1: "Vols directs aller-retour depuis l'Europe",
      flight2: "Bagage de 20 kg + Bagage cabine",
      trans1: "Accueil à l'aéroport et transfert",
      trans2: "Chauffeur privé professionnel & guide touristique",
      trans3: "Nouveaux véhicules climatisés",
      hotel1: "Hôtels 4–5 étoiles",
      hotel2: "Emplacements premium",
      hotel3: "Service haut de gamme",
      food1: "Demi-pension",
      food2: "Cuisine authentique",
      food3: "Thé traditionnel & pâtisseries",
      exp1: "Spectacles marocains en direct",
      exp2: "Marchés traditionnels (Épices, Lanternes, Tapis)",
      exp3: "Hammam marocain traditionnel",
      exp4: "Visites de la nature & des forêts",
      exp5: "Beaux belvédères & Excursions d'une journée",
      exp6: "Ateliers de cuisine et d'art",
      exp7: "Visites chez des familles locales",
      exp8: "Surprises spéciales pendant le voyage",
      suit1: "Couples",
      suit2: "Familles",
      suit3: "Groupes",
      suit4: "Voyageurs solo",
      suit5: "Seniors",
      suit6: "Entreprises",
      suit7: "Agences de voyages"
    },
    pkg3: {
      title: "Grande Expérience du Maroc",
      duration: "10 Nuits / 11 Jours (Voyageurs du monde entier)",
      price: "1990 €",
      hl1: "Services terrestres premium complets",
      hl2: "Casablanca, Marrakech & Fès",
      hl3: "Agadir & surprises du désert du Sahara",
      hl4: "Visite de Ouarzazate & Chefchaouen",
      hl5: "Musique en direct & spectacles spéciaux",
      subtitle: "✨ Grande Expérience du Maroc (Services Terrestres Uniquement)",
      arrivalText: "Casablanca ou Marrakech",
      routeText: "Casablanca, Rabat, 2 nuits à Fès, Tanger, Chefchaouen, Ifrane, 2 nuits à Marrakech, Agadir, Ouarzazate, dernière nuit à Marrakech",
      note2: "Groupes > 40 : Remise spéciale de 50 $ par personne",
      note3: "Vols internationaux & assurance NON inclus",
      note4: "Pourboires pour chauffeur/guide NON inclus",
      inc1: "Services terrestres premium complets",
      inc2: "Hôtels 4–5 étoiles (Demi-pension)",
      inc3: "Guide touristique professionnel & Chauffeur privé",
      inc4: "Bus ou minibus climatisé",
      inc5: "Spectacles en direct & ambiance musicale",
      inc6: "Marchés traditionnels & visites de Hammam",
      inc7: "Ateliers de cuisine et d'art",
      inc8: "Excursions dans les forêts, sources & belvédères",
      inc9: "Visites chez des familles locales",
      inc10: "Surprises spéciales pendant le voyage"
    },
    pkg4: {
      title: "Expérience Impériale & Sahara du Maroc",
      duration: "13 Nuits / 14 Jours",
      price: "Tout Inclus",
      hl1: "2 Nuits dans le Désert du Sahara à Merzouga",
      hl2: "Tentes climatisées premium & excursions en Jeep",
      hl3: "Visite des montagnes de l'Atlas & de la vallée de l'Ourika",
      hl4: "Cascades d'Ouzoud & Villes Impériales",
      hl5: "Services terrestres complets de A à Z",
      subtitle: "✨ Expérience Impériale & Sahara du Maroc (Services Terrestres Complets)",
      routeText: "2 nuits à Marrakech, vallée de l'Ourika, Agadir, 2 nuits à Merzouga, Ouarzazate, cascades d'Ouzoud, Ifrane, Tanger, Chefchaouen, 2 nuits à Fès, El Jadida, Casablanca",
      sahara1: "Tentes de désert premium climatisées",
      sahara2: "Ambiance musicale au feu de camp",
      sahara3: "Excursions en Jeep & balades à chameau",
      sahara4: "Couchers & levers de soleil inoubliables",
      inc1: "Services terrestres premium complets",
      inc2: "Hôtels 4–5 étoiles (Demi-pension)",
      inc3: "Guide touristique professionnel & Chauffeur privé",
      inc4: "Spectacles en direct spéciaux & danseurs",
      inc5: "Marchés traditionnels d'épices, de tapis & de lanternes",
      inc6: "Hammam marocain traditionnel",
      inc7: "Ateliers de cuisine et d'art"
    }
  },
  destinations: {
    pageTitle: "Explorez les Destinations du Maroc",
    pageSubtitle: "Découvrez des endroits incroyables à visiter à travers le magnifique Maroc",
    sectionTitle: "Toutes les Destinations",
    sectionIntro: "Le Maroc est un pays aux paysages variés et au riche patrimoine culturel. Explorez nos destinations soigneusement sélectionnées :",
    exploreNow: "Explorer",
    ctaTitle: "Prêt à Planifier Votre Voyage ?",
    ctaText: "Parcourez nos circuits et forfaits pour trouver l'expérience marocaine parfaite",
    ctaBtn: "Voir les Circuits & Forfaits"
  },
  experiences: {
    pageTitle: "Excellence Culinaire Marocaine",
    pageSubtitle: "Découvrez notre cuisine — la meilleure au monde",
    bookViaWhatsApp: "Réserver via WhatsApp",
    introTitle: "Notre Expérience Culinaire Unique au Maroc",
    introHighlight: "Des saveurs authentiques, des ingrédients frais, des siècles de tradition et une hospitalité inoubliable.",
    introP1: "Bienvenue aux saveurs authentiques du Maroc.",
    introP2: "Chez Morocco Loves You, manger n'est pas seulement se nourrir — c'est de la culture, de l'histoire, de la famille, de l'hospitalité et de l'amour.",
    introP3: "Depuis des siècles, la cuisine marocaine est considérée comme l'une des cuisines les plus riches, les plus saines et les plus savoureuses au monde.",
    introP4: "Nos traditions culinaires combinent des influences arabes, berbères, juives marocaines, andalouses, méditerranéennes et africaines — créant des recettes uniques préservées depuis plus de 500 ans.",
    prepTitle: "L'Art de la Préparation Marocaine",
    prepP1: "Tout est préparé avec soin, passion, ingrédients locaux frais et épices marocaines authentiques.",
    prepP2: "Nous sélectionnons soigneusement des restaurants de confiance, des expériences locales authentiques et des destinations culinaires de qualité pour nos clients.",
    prepP3: "Le Maroc est connu dans le monde entier pour ses marchés colorés, son agriculture fraîche, ses produits naturels, ses épices, ses olives, ses oranges, ses pâtisseries, son thé à la menthe et son hospitalité inoubliable.",
    journeyVideos: "Vidéos de notre Voyage Culinaire",
    highlightsTitle: "Points Forts Culinaires Traditionnels",
    highlightTagine: "Tajine Marocain Authentique",
    highlightCouscous: "Couscous Traditionnel",
    highlightVegetables: "Légumes frais & ingrédients naturels",
    highlightPastries: "Pâtisseries & desserts faits maison",
    highlightBreakfasts: "Petits-déjeuners marocains traditionnels",
    highlightMeat: "Poisson frais & viandes de qualité",
    highlightJuices: "Jus naturels & thé marocain",
    highlightHealthy: "Traditions culinaires saines et délicieuses",
    galleryTitle: "Notre Galerie Culinaire",
    summaryP1: "Notre but est d'offrir à nos invités non seulement un voyage — mais un véritable périple culinaire marocain.",
    tagHealthy: "Sain",
    tagAuthentic: "Authentique",
    tagTraditional: "Traditionnel",
    tagFresh: "Frais",
    tagUnique: "Unique",
    tagDelicious: "Délicieux",
    important: "Important :",
    guidanceNote: "Pour la meilleure expérience culinaire, nous vous recommandons vivement de suivre les conseils de notre équipe et nos recommandations culinaires pendant votre voyage au Maroc.",
    whereMeal: "Là où chaque repas devient un souvenir.",
    whatsappLabel: "WhatsApp : +972 54-633-8757",
    moroccoLine: "Ligne Maroc : +212 6 63 63 05 79"
  },
  vip: {
    pageTitle: "Voyage VIP & Affaires",
    pageSubtitle: "Services exclusifs pour PDG, investisseurs et voyageurs exigeants",
    introTitle: "L'Excellence Sans Faille au Maroc",
    introText: "MoroccoLovesYou offre un service incomparable pour les voyageurs d'affaires, les délégations et les invités VIP. Nous comprenons que votre temps est précieux. De l'atterrissage au départ, nous gérons chaque détail avec précision.",
    ctaTitle: "Accès Direct au PDG",
    ctaText: "Pour les demandes urgentes et hautement spécialisées, parlez directement avec notre Fondateur et PDG, Ilan Hatchuel.",
    ctaBtn: "Contacter Ilan Maintenant",
    luxuryTransport: "Transport de Luxe",
    luxuryTransportDesc: "Transferts VIP aéroport et chauffeurs bilingues privés 24h/24 avec véhicules de luxe.",
    premiumAccom: "Hébergements Premium",
    premiumAccomDesc: "Réservations exclusives dans des hôtels 5 étoiles, riads de luxe ou villas privées.",
    businessConcierge: "Conciergerie Affaires",
    businessConciergeDesc: "Assistance complète pour réunions, réservations de dîners privés et itinéraires spécialisés.",
    securityPrivacy: "Sécurité & Confidentialité",
    securityPrivacyDesc: "Service discret, environnements sécurisés et confidentialité absolue.",
    support247: "Support 24h/24",
    support247Desc: "Contact direct avec le PDG et une équipe dédiée prête à vous assister à tout moment.",
    customItineraries: "Itinéraires Sur Mesure",
    customItinerariesDesc: "Plans de voyage sur mesure équilibrant parfaitement vos obligations professionnelles et les expériences culturelles marocaines."
  },
  worldcup: {
    pageTitle: "Coupe du Monde Maroc 2030",
    pageSubtitle: "Forfaits VIP Exclusifs pour le Plus Grand Événement Sportif",
    limitedBadge: "Disponibilité Limitée",
    introTitle: "Le Voyage Footballistique Ultime",
    introText: "En 2030, le Maroc co-organisera la Coupe du Monde FIFA. MoroccoLovesYou est fier d'offrir des forfaits de luxe tout compris exclusifs conçus pour les fans qui exigent le meilleur.",
    packagesTitle: "Forfaits Coupe du Monde Premium",
    silverTitle: "Forfait Argent",
    silverSub: "L'Expérience Essentielle",
    goldTitle: "Forfait Or",
    goldSub: "L'Expérience de Luxe",
    mostPopular: "Le Plus Populaire",
    diamondTitle: "Diamant VIP",
    diamondSub: "L'Expérience Ultime",
    inquireWhatsApp: "Demander via WhatsApp",
    ctaTitle: "Réservez Avant la Hausse des Prix",
    ctaText: "En raison de la forte demande internationale, nous recommandons vivement de réserver votre forfait VIP rapidement.",
    ctaBtn: "Contactez-nous Aujourd'hui",
    silverF1: "Riad Premium / Hôtel 4 étoiles",
    silverF2: "Logistique Jour de Match Pré-planifiée",
    silverF3: "Visites Guidées des Villes Hôtes",
    silverF4: "Ligne de Support Dédiée 24h/24",
    goldF1: "Hôtel 5 étoiles / Villa de Luxe",
    goldF2: "Transferts Privés Aéroport & Matchs",
    goldF3: "Séjour VIP Camp Désert (2 Jours)",
    goldF4: "Concierge Personnel Bilingue",
    diamondF1: "Suites Présidentielles / Palais Privés",
    diamondF2: "Chauffeur Privé & Sécurité 24h/24",
    diamondF3: "Accès Exclusif aux Événements VIP",
    diamondF4: "Gestion Directe PDG & Concierge VVIP"
  },
  gallery: {
    pageTitle: "Notre Galerie",
    pageSubtitle: "Souvenirs visuels de voyages marocains inoubliables",
    picturesTitle: "Le Maroc en Images",
    picturesIntro: "Explorez notre collection de photos époustouflantes du Maroc",
    videosTitle: "Le Maroc en Mouvement",
    videosIntro: "Découvrez le Maroc à travers notre collection vidéo"
  },
  testimonials: {
    pageTitle: "Témoignages Clients",
    pageSubtitle: "Lisez ce que nos voyageurs disent de leur expérience marocaine",
    sectionTitle: "Nos Voyageurs Satisfaits",
    sectionIntro: "Des milliers de clients satisfaits ont vécu la magie du Maroc avec nous",
    verifiedGuest: "Client Vérifié",
    ratingsTitle: "Nos Notes",
    avgRating: "Note Moyenne",
    verifiedReviews: "Avis Vérifiés",
    fromReal: "De vrais voyageurs",
    custSatisfaction: "Satisfaction Client",
    wouldRecommend: "Recommanderaient",
    shareTitle: "Partagez Votre Expérience",
    shareText: "Vous avez vécu un voyage incroyable ? Racontez-nous !",
    shareBtn: "Racontez Votre Histoire"
  },
  blog: {
    pageTitle: "Blog de Voyage",
    pageSubtitle: "Histoires, conseils et guides pour votre aventure marocaine",
    sectionTitle: "Derniers Articles de Voyage",
    sectionIntro: "Lisez nos derniers articles sur le voyage au Maroc, la culture locale et les conseils d'initiés",
    readMore: "Lire la Suite →",
    by: "Par",
    newsletterTitle: "Abonnez-vous à Notre Newsletter",
    newsletterText: "Recevez les derniers conseils de voyage et offres exclusives",
    newsletterPlaceholder: "Entrez votre e-mail",
    subscribe: "S'abonner"
  },
  contact: {
    pageTitle: "Contactez-nous",
    pageSubtitle: "Contactez notre équipe pour planifier votre aventure VIP au Maroc",
    getInTouch: "Contactez-nous",
    getInTouchText: "Nous sommes là pour vous aider et répondre à toutes vos questions. Notre équipe est prête à vous assister dans la planification de votre voyage parfait au Maroc.",
    address: "Adresse",
    phone: "Téléphone",
    email: "E-mail",
    businessHours: "Heures d'Ouverture",
    followUs: "Suivez-nous",
    formTitle: "Envoyez-nous un Message",
    successMessage: "✓ Merci ! Nous vous répondrons bientôt.",
    fullName: "Nom Complet",
    emailAddress: "Adresse E-mail",
    phoneNumber: "Numéro de Téléphone",
    subject: "Sujet",
    selectSubject: "Sélectionnez un sujet",
    tourInquiry: "Demande de Circuit",
    bookingQuestion: "Question de Réservation",
    customPackage: "Forfait Personnalisé",
    feedback: "Commentaires",
    other: "Autre",
    message: "Message",
    sendMessage: "Envoyer le Message",
    mapTitle: "Trouvez-nous sur la Carte",
    faqTitle: "Questions Fréquemment Posées",
    faq1Q: "Quelle est la meilleure période pour visiter le Maroc ?",
    faq1A: "Le printemps (avril-mai) et l'automne (septembre-octobre) offrent le meilleur temps.",
    faq2Q: "Ai-je besoin d'un visa pour visiter le Maroc ?",
    faq2A: "Les exigences de visa dépendent de votre nationalité. De nombreux pays bénéficient d'une entrée sans visa jusqu'à 90 jours.",
    faq3Q: "Quelle monnaie est utilisée au Maroc ?",
    faq3A: "Le Dirham marocain (MAD) est la monnaie officielle. Les distributeurs automatiques sont largement disponibles.",
    faq4Q: "Quelle langue parle-t-on au Maroc ?",
    faq4A: "L'arabe et le berbère (amazigh) sont les langues officielles. Le français est largement parlé.",
    faq5Q: "Le Maroc est-il sûr pour les touristes ?",
    faq5A: "Oui, le Maroc est généralement sûr pour les touristes. Nos guides assurent une expérience sûre et agréable.",
    faq6Q: "Puis-je personnaliser mon forfait ?",
    faq6A: "Absolument ! Nous proposons des forfaits personnalisés adaptés à vos intérêts, budget et dates de voyage."
  },
  about: {
    pageTitle: "À Propos de MoroccoLovesYou",
    pageSubtitle: "Votre partenaire de confiance pour découvrir la magie du Maroc",
    storyTitle: "Notre Histoire",
    storyP1: "MoroccoLovesYou a été fondé avec une mission simple : aider les voyageurs à vivre la beauté authentique, la culture et l'hospitalité du Maroc.",
    storyP2: "Notre fondatrice est tombée amoureuse du Maroc et a voulu partager cette passion avec le monde entier.",
    missionTitle: "🎯 Notre Mission",
    missionText: "Offrir des expériences de voyage exceptionnelles qui mettent en valeur le riche patrimoine culturel du Maroc.",
    visionTitle: "🌟 Notre Vision",
    visionText: "Être la première entreprise touristique du Maroc reconnue pour son authenticité et sa fiabilité.",
    whyTitle: "Pourquoi Choisir MoroccoLovesYou ?",
    expertTitle: "Expertise",
    expertText: "Notre équipe possède une connaissance approfondie du Maroc.",
    localTitle: "Connexions Locales",
    localText: "Nous travaillons avec des guides et familles locaux authentiques.",
    valueTitle: "Meilleur Rapport Qualité-Prix",
    valueText: "Prix compétitifs sans compromis sur la qualité.",
    safetyTitle: "Sécurité & Support",
    safetyText: "Support client 24h/24 et assurance voyage complète incluse.",
    sustainTitle: "Tourisme Durable",
    sustainText: "Nous soutenons les communautés locales et pratiquons un tourisme responsable.",
    bookingTitle: "Réservation Facile",
    bookingText: "Processus de réservation simple avec options de paiement flexibles.",
    teamTitle: "Notre Équipe",
    teamSubtitle: "Rencontrez les passionnés derrière MoroccoLovesYou",
    happyTravelers: "Voyageurs Satisfaits",
    yearsExp: "Années d'Expérience",
    destinationsCount: "Destinations",
    satisfactionRate: "Taux de Satisfaction"
  },
  footer: {
    description: "Découvrez la magie du Maroc avec nous. Vivez des aventures inoubliables et créez des souvenirs durables.",
    quickLinks: "Liens Rapides",
    more: "Plus",
    contactInfo: "Infos Contact",
    copyright: "© 2024 MoroccoLovesYou. Tous droits réservés."
  },
  starBanner: {
    ceoMessage: "MESSAGE DU PDG",
    watchVideo: "Regardez ma vidéo",
    readMessage: "& lisez mon message",
    getToKnow: "Apprenez à connaître",
    ilanPersonally: "Ilan personnellement"
  },
  tourMini: {
    days: "10 JOURS",
    nights: "/ 9 NUITS",
    title: "CIRCUIT PREMIUM\nMAROC",
    years: "2026 - 2027",
    departures: "DÉPARTS MENSUELS",
    allIncluded: "TOUT COMPRIS\nPENSION COMPLÈTE",
    recommendations: "Recommandations",
    recCount: "500+ voyageurs heureux"
  },
  cityDetail: {
    notFound: "Ville non trouvée",
    backHome: "Retour à l'accueil",
    discoverSubtitle: "Découvrez la beauté et la culture",
    planTrip: "Planifier mon voyage à",
    galleryOf: "Galerie de",
    bookExperience: "Réserver cette expérience",
    requestItinerary: "Demander l'itinéraire complet",
    readyToVisit: "Prêt à visiter",
    readyToVisitText: "Laissez-nous planifier votre voyage parfait vers cette destination incroyable",
    planMyTrip: "Planifier mon voyage",
    talkExpert: "Parler à un expert"
  },
  transportation: {
    pageTitle: "Transport VIP & Chauffeurs",
    pageSubtitle: "Luxe, Confort & Sécurité à travers le Maroc",
    introTitle: "Nos Chauffeurs & Transports VIP",
    introP1: "Chez Morocco Loves You, le transport ne consiste pas seulement à se déplacer d'un endroit à un autre.",
    introP2: "Cela fait partie de l'expérience.",
    introP3: "Nous fournissons des véhicules modernes, propres, confortables et entièrement climatisés dans tout le Maroc — avec des chauffeurs professionnels, une hospitalité chaleureuse et un service VIP dès le premier instant.",
    introP4: "Que vous voyagiez en couple, en famille, en délégation d'affaires ou en groupe privé, nous veillons à ce que votre voyage soit sûr, relaxant et inoubliable.",
    servicesTitle: "Nos services de transport comprennent",
    servicesList: [
      "Bus VIP modernes",
      "Minibus de luxe",
      "Voitures privées",
      "Jeeps 4x4 pour les aventures dans le désert",
      "Limousines VIP",
      "Prise en charge et retour à l'aéroport",
      "Chauffeurs professionnels multilingues",
      "Climatisation confortable",
      "Véhicules propres et organisés",
      "Réfrigérateurs dans certains véhicules",
      "Systèmes de télévision et de divertissement",
      "Musique pendant le voyage",
      "Conduite sûre et fluide",
      "Assistance 24h/24 et 7j/7 dans tout le Maroc"
    ],
    driversTitle: "Rencontrez nos chauffeurs",
    driversText1: "Nos chauffeurs font partie de la famille Morocco Loves You.",
    driversText2: "Professionnels, respectueux, expérimentés et toujours prêts à aider avec le sourire.",
    driversText3: "Beaucoup de nos chauffeurs parlent plusieurs langues et connaissent profondément le Maroc — aidant nos clients à se sentir à l'aise, en sécurité et connectés tout au long du voyage.",
    safetyTitle: "La sécurité et le confort d'abord",
    safetyText1: "Votre confort et votre sécurité sont nos priorités absolues.",
    safetyText2: "Tous les véhicules sont régulièrement entretenus, nettoyés et soigneusement préparés avant chaque voyage.",
    safetyText3: "Nous ne travaillons qu'avec des chauffeurs professionnels de confiance et des partenaires de transport de haute qualité.",
    categories: {
      buses: "Bus VIP",
      minibuses: "Minibus de luxe",
      cars: "Voitures privées & transferts VIP",
      jeeps: "Jeeps 4x4 & transport dans le désert",
      meetDrivers: "Rencontrez nos chauffeurs",
      videos: "Vidéos de l'expérience de transport"
    },
    videoGalleryTitle: "Vidéos de l'expérience VIP",
    ctaTitle: "Prêt à explorer le Maroc en tout confort ?",
    ctaSubtitle: "Parlez directement avec Allan – PDG et fondateur",
    whatsapp: "WhatsApp : +972546338757",
    moroccoLine: "Ligne directe Maroc : +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "Circuits Casher de Luxe au Maroc",
    pageSubtitle: "Héritage juif authentique, cuisine 100% casher, hospitalité de luxe & expériences uniques au Maroc.",
    introTitle: "Expérience de Luxe du Patrimoine Juif",
    introHeading: "Découvrez le Maroc Juif Authentique",
    introText: "Découvrez les racines profondes de l'histoire juive au Maroc avec une expérience de voyage élégante, authentique et haut de gamme. Nous sommes spécialisés dans l'organisation de voyages fluides pour les communautés juives du monde entier, axés sur le patrimoine, la connexion et le confort absolu.",
    introQuote: "\"Le Maroc est une terre de tolérance et de coexistence, où le patrimoine juif est préservé avec amour et respect.\"",
    experiencesTitle: "Nos Expériences Casher Comprennent",
    experiencesList: [
      "Nourriture & Restaurants 100% Casher",
      "Chef Casher Privé Disponible",
      "Cuisine Juive Marocaine Traditionnelle",
      "Hôtels de Luxe 4 & 5 Étoiles",
      "Transport Privé VIP",
      "Guides Professionnels Multilingues",
      "Visites du Patrimoine Juif & Synagogues",
      "Cimetières & Musées Juifs",
      "Expériences Désert du Sahara & Hammam",
      "Assistance Professionnelle 24h/24 & 7j/7"
    ],
    expFood: "Alimentation 100% Casher",
    expRestaurant: "Restaurant Casher",
    expChef: "Chef Casher Privé Disponible",
    expCuisine: "Cuisine Juive Marocaine Traditionnelle",
    expHotels: "Hôtels de Luxe 4 & 5 Étoiles",
    expDeluxeHotels: "Hôtels de grand standing sur demande",
    expTransport: "Transport Privé VIP",
    expDrivers: "Chauffeurs Professionnels",
    expAC: "Véhicules Climatisés",
    expWifi: "WiFi, TV & Réfrigérateurs dans certains véhicules",
    expGuides: "Guides Professionnels Multilingues",
    expStaff: "Personnel parlant hébreu / anglais / français / espagnol / russe / allemand",
    expHeritage: "Visites du Patrimoine Juif",
    expSynagogues: "Synagogues Anciennes",
    expCemeteries: "Cimetières Juifs",
    expMuseums: "Musées Juifs",
    expSpiritual: "Expériences Spirituelles & Culturelles",
    expDesert: "Expériences Désert du Sahara",
    expHammam: "Expériences Hammam Marocain",
    expAttractions: "Attractions uniques dans tout le Maroc",
    expAssistance: "Assistance 24/7",
    packagesTitle: "Forfaits de Voyage Casher Flexibles",
    packagesIntro: "Nous personnalisons chaque voyage selon les besoins, les traditions, le style de voyage, les dates et les attentes de nos invités.",
    packageOptions: ["4–5 Jours", "7–8 Jours", "10–11 Jours", "13–14 Jours", "21 Jours", "Circuits Privés Sur Mesure"],
    package4_5: "4–5 Jours",
    package7_8: "7–8 Jours",
    package10_11: "10–11 Jours",
    package13_14: "13–14 Jours",
    package21: "21 Jours",
    packageTailor: "Circuits Privés Sur Mesure",
    packagesQuote: "“Nous personnalisons chaque voyage selon les besoins, les traditions, le style de voyage, les dates et les attentes de nos invités.”",
    safetyTitle: "Voyage Confortable, Professionnel & Sûr",
    safetyText: "Nos circuits fonctionnent avec une attention particulière accordée au confort, à l'organisation, à la qualité du service et à la coordination professionnelle à travers le Maroc.",
    safetyQuote: "“Nos circuits fonctionnent avec une attention particulière accordée au confort, à l'organisation, à la qualité du service et à la coordination professionnelle à travers le Maroc.”",
    b2bTitle: "Partenariats de Voyage Juifs B2B",
    b2bText: "Nous collaborons avec les communautés juives, les synagogues, les rabbins et les voyagistes casher du monde entier pour créer des voyages patrimoniaux significatifs.",
    b2bPartnersList: "Nous travaillons avec : Communautés juives, Synagogues, Rabbins, Organisations juives, Voyagistes casher et Agences de voyages du monde entier.",
    partnerBtn: "Devenir Partenaire",
    galleryTitle: "Galerie de l'Expérience Casher",
    videosTitle: "Vidéos à la Une",
    ctaTitle: "Prêt à commencer votre voyage ?",
    msgAllan: "Envoyer un message à Allan sur WhatsApp",
    callMorocco: "Appeler le Maroc : +212 6 63 63 05 79",
    ceoContact: "Parlez directement avec Allan Hatchuel sur WhatsApp",
    exploreBtn: "Explorer les Circuits Casher"
  },
  
  // Accessibility & UI Labels (Étiquettes d'Accessibilité et Interface)
  aria: {
    selectLanguage: "Sélectionner la langue",
    closeDetails: "Fermer les détails",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    kosherTravel: "Voyages Casher au Maroc",
    watchVideo: "Regarder la vidéo Maroc Magique",
    followInstagram: "Nous suivre sur Instagram",
    followFacebook: "Nous suivre sur Facebook",
    ceoMessage: "PDG de Morocco Loves You",
    whatsappSocial: "WhatsApp",
    instagramSocial: "Instagram",
    facebookSocial: "Facebook",
    jewishHeritageExperience: "Expérience du patrimoine juif",
    kosherFoodMorocco: "Cuisine casher au Maroc",
    jewishHeritageMorocco: "Patrimoine juif au Maroc",
    kosherExperience: "Expérience casher",
    luxuryHospitality: "Hospitalité de luxe",
    kosherMoroccanTable: "Table marocaine casher",
    jewishHeritageArchitecture: "Architecture du patrimoine juif",
    kosherOptionsAlt: "Options casher",
    kingAlt: "Roi du Maroc",
    logoAlt: "Logo MoroccoLovesYou"
  },
  
  // Form Placeholders (Espaces Réservés du Formulaire)
  forms: {
    firstName: "ex. Jean",
    lastName: "ex. Dupont",
    email: "nom@exemple.com",
    subject: "Comment pouvons-nous vous aider ?",
    message: "Parlez-nous davantage de vos plans de voyage...",
    phone: "Votre numéro de téléphone",
    date: "Sélectionner une date",
    guests: "Nombre de clients"
  },
  
  // Common UI Text (Texte Commun de l'Interface)
  common: {
    selectLanguage: "Sélectionner la langue",
    instagram: "Instagram",
    facebook: "Facebook",
    loading: "Chargement...",
    error: "Une erreur s'est produite",
    success: "Succès !",
    noResults: "Aucun résultat trouvé",
    viewMore: "Voir Plus",
    viewLess: "Voir Moins",
    bookNow: "Réserver Maintenant",
    learnMore: "En Savoir Plus",
    contactUs: "Nous Contacter",
    close: "Fermer",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    search: "Rechercher...",
    filter: "Filtrer",
    sort: "Trier",
    price: "Prix",
    duration: "Durée",
    languages: {
      english: "English",
      american: "American",
      australia: "Australia",
      canada: "Canada",
      french: "Français",
      spanish: "Español",
      hebrew: "עברית",
      arabic: "العربية",
      german: "Deutsch",
      italian: "Italiano",
      japanese: "日本語",
      chinese: "中文",
      korean: "한국어",
      vietnamese: "Tiếng Việt",
      russian: "Русский"
    }
  },
  
  // WhatsApp Message Templates (Modèles de Messages WhatsApp)
  whatsapp: {
    greeting: "Bonjour Morocco Loves You! 🌟",
    bookPackage: "J'aimerais réserver le forfait suivant :",
    packageInfo: "📦 Forfait : ",
    duration: "⏱️ Durée : ",
    price: "💰 Prix : ",
    bookingRequest: "Veuillez me faire savoir la disponibilité et les prochaines étapes. Merci !",
    cityTrip: "J'aimerais planifier un voyage à {city}. Pouvez-vous m'aider ?",
    silverPackage: "Je suis intéressé par le forfait Silver de la Coupe du Monde",
    goldPackage: "Je suis intéressé par le forfait Gold de la Coupe du Monde",
    diamondPackage: "Je suis intéressé par le forfait Diamond VIP de la Coupe du Monde",
    worldCupSecure: "Bonjour, je veux sécuriser ma place pour le Maroc 2030.",
    kosherInquiry: "Je suis intéressé par vos forfaits de voyage casher.",
    customPackage: "J'aimerais créer un forfait personnalisé pour notre groupe.",
    businessInquiry: "Je suis intéressé par les services de voyage d'affaires VIP."
  },
  
  // Blog Posts (Articles de Blog)
  blog_posts: {
    post1: {
      title: "10 Joyaux Cachés à Découvrir au Maroc",
      author: "Fatima Hassan",
      date: "15 mars 2024",
      category: "Guide de Voyage",
      excerpt: "Découvrez les destinations les moins connues et les trésors cachés du Maroc. Des villages secrets en montagne aux zones côtières vierges.",
      content: "Le Maroc est bien plus que Marrakech et Casablanca. Ce guide complet révèle des joyaux cachés..."
    },
    post2: {
      title: "Meilleure Période pour Visiter le Maroc : Guide Complet",
      author: "Ahmed Bennani",
      date: "10 mars 2024",
      category: "Planification",
      excerpt: "Planifiez votre voyage au Maroc ? Apprenez les meilleures saisons pour visiter.",
      content: "Choisir le bon moment pour visiter le Maroc peut impacter significativement votre expérience de voyage..."
    },
    post3: {
      title: "Cuisine Marocaine : Une Aventure Culinaire",
      author: "Layla Rahim",
      date: "5 mars 2024",
      category: "Nourriture et Culture",
      excerpt: "Embarquez dans un voyage culinaire à travers le Maroc. Découvrez les saveurs riches et les recettes traditionnelles.",
      content: "La cuisine marocaine est un mélange d'influences arabes, amazighes, andalouses et africaines..."
    },
    post4: {
      title: "Comment Marchander au Maroc Comme un Pro",
      author: "Youssef Alaoui",
      date: "28 février 2024",
      category: "Conseils de Voyage",
      excerpt: "Maîtrisez l'art de la négociation dans les souks et marchés marocains. Apprenez les tactiques et conseils.",
      content: "La négociation sur les marchés marocains n'est pas qu'une transaction ; c'est un échange culturel..."
    },
    post5: {
      title: "Randonnée dans les Montagnes de l'Atlas : Ce qu'il Faut Savoir",
      author: "Ahmed Bennani",
      date: "20 février 2024",
      category: "Aventure",
      excerpt: "Explorez les majestueuses Montagnes de l'Atlas à pied. Obtenez des conseils d'experts sur les itinéraires et l'équipement.",
      content: "Les Montagnes de l'Atlas offrent certains des paysages les plus spectaculaires du nord de l'Afrique..."
    },
    post6: {
      title: "Safari du Désert : Une Expérience Inoubliable",
      author: "Fatima Hassan",
      date: "15 février 2024",
      category: "Aventure",
      excerpt: "Expérimentez la magie du désert du Sahara marocain. Promenades à chameau et nuits sous les étoiles.",
      content: "Le désert du Sahara représente l'âme du Maroc. Un safari au désert est bien plus qu'une aventure..."
    },
    post7: {
      title: "Étiquette Culturelle : Respecter les Traditions Marocaines",
      author: "Layla Rahim",
      date: "10 février 2024",
      category: "Culture",
      excerpt: "Apprenez les normes culturelles essentielles pour interagir respectueusement avec le peuple marocain.",
      content: "Comprendre et respecter les coutumes locales est crucial quand on voyage au Maroc..."
    },
    post8: {
      title: "Photographie au Maroc : Capturer la Magie",
      author: "Youssef Alaoui",
      date: "5 février 2024",
      category: "Photographie",
      excerpt: "Découvrez les endroits les plus photogéniques du Maroc et les conseils professionnels pour capturer des images magnifiques.",
      content: "Le Maroc est un paradis pour les photographes. Des médinas bleues aux déserts dorés..."
    }
  },
  
  // Job Listings (Offres d'Emploi)
  jobs: {
    title: "Carrières et Opportunités",
    intro: "Rejoignez l'équipe de MoroccoLovesYou et construisez votre avenir dans les voyages de luxe",
    workWith: "Travaillez avec Amour, Soin et Excellence",
    introText: "Nous recherchons des individus passionnés et dédiés qui partagent notre vision d'offrir des expériences de voyage de classe mondiale.",
    openPositions: "Postes Ouverts",
    readyJoin: "Prêt à Nous Rejoindre ?",
    sendCV: "Envoie ton CV à careers@moroccolovesyou.com",
    instructions: "Inclure une brève lettre de motivation expliquant pourquoi vous souhaitez rejoindre l'équipe Morocco Loves You.",
    
    job1: {
      title: "Guide Touristique Professionnel Multilingue",
      type: "Temps Plein / Saisonnier",
      location: "Marrakech / Fès / Maroc",
      description: "Nous recherchons des guides passionnés et connaisseurs qui peuvent donner vie au Maroc pour nos clients VIP.",
      req1: "Couramment parlé dans au moins 2 langues (français, espagnol, anglais, hébreu, allemand, russe ou italien préféré)",
      req2: "Connaissance approfondie de l'histoire, la culture et la géographie marocaines",
      req3: "Compétences professionnelles, conviviales et excellent service à la clientèle",
      req4: "Aptitude physique pour le trekking dans le désert et les activités de plein air"
    },
    job2: {
      title: "Chauffeur Exécutif Luxe",
      type: "Temps Plein",
      location: "Maroc",
      description: "Rejoignez notre équipe de transport de luxe en conduisant des véhicules Mercedes haut de gamme.",
      req1: "Permis de conduire valide avec un excellent dossier de conduite (10+ ans d'expérience préféré)",
      req2: "Couramment parlé l'anglais (langues supplémentaires, bonus)",
      req3: "Apparence professionnelle et comportement courtois",
      req4: "Connaissance des routes et itinéraires du Maroc"
    },
    job3: {
      title: "Coordinateur de l'Expérience Client",
      type: "Temps Plein",
      location: "Télétravail / Hybride (Bureau Fès)",
      description: "Supportez le bureau du PDG en organisant des itinéraires de luxe personnalisés et en gérant les communications avec les clients.",
      req1: "Excellentes compétences organisationnelles et communicationnelles",
      req2: "Expérience en voyage, hôtellerie ou service à la clientèle",
      req3: "Courant anglais ; langues supplémentaires bonus",
      req4: "Compétence avec les systèmes de réservation et la suite Microsoft Office"
    }
  },
  
  // Testimonials (Témoignages)
  testimonials_data: {
    intro: "Rencontrez nos clients satisfaits qui ont expérimenté le Maroc avec nos services",
    
    testi1: {
      name: "Sarah Johnson",
      title: "Londres, Royaume-Uni",
      rating: 5,
      text: "Morocco Loves You a rendu mon voyage de rêve réalité ! Chaque détail était parfaitement organisé. Le service est incomparable.",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330"
    },
    testi2: {
      name: "Michael Chen",
      title: "Singapour",
      rating: 5,
      text: "En tant que voyageur d'affaires, j'ai été impressionné par le professionnalisme et la personnalisation. Traitement VIP dès le premier jour.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
    },
    testi3: {
      name: "Emma Wilson",
      title: "Sydney, Australie",
      rating: 5,
      text: "L'expérience du désert était magique ! Dormir sous les étoiles et la chaleur de l'hospitalité marocaine ont dépassé toutes mes attentes.",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80"
    },
    testi4: {
      name: "James Rodriguez",
      title: "Madrid, Espagne",
      rating: 5,
      text: "Planifier un voyage en famille peut être stressant, mais Morocco Loves You a tout géré brillamment. Sûr, éducatif et amusant !",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e"
    },
    testi5: {
      name: "Anna Mueller",
      title: "Berlin, Allemagne",
      rating: 5,
      text: "J'ai apprécié l'authenticité culturelle et le respect des traditions locales. Ce n'était pas juste du tourisme ; c'était une immersion culturelle authentique.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
    },
    testi6: {
      name: "David Thompson",
      title: "Toronto, Canada",
      rating: 5,
      text: "L'accessibilité pour les personnes âgées était exceptionnelle. Rythme confortable, guides attentionnés et hébergements de luxe.",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e"
    },
    testi7: {
      name: "Lisa Anderson",
      title: "New York, États-Unis",
      rating: 5,
      text: "Les amateurs de bonne nourriture trouveront ici leur compte ! Les expériences culinaires étaient exquises. Chaque repas raconte une histoire.",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80"
    },
    testi8: {
      name: "Marcus Smith",
      title: "Los Angeles, États-Unis",
      rating: 5,
      text: "Rempli d'aventure mais luxueux - exactement ce que je cherchais. Randonnée dans l'Atlas et safaris au désert avec le confort VIP.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
    },
    testi9: {
      name: "Sophie Laurent",
      title: "Paris, France",
      rating: 5,
      text: "Voyage romantique extraordinaire ! Coucher de soleil au Sahara, dîners privés surplombant Marrakech. Service attentionné tout au long.",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330"
    }
  },
  
  // Gallery Categories (Catégories de Galerie)
  gallery_categories: {
    food: "Expérience Culinaire",
    destinations: "Destinations",
    kosher: "Casher",
    transport: "Transport VIP"
  },
  
  // Stats (Statistiques)
  stats: {
    happyTravelers: "5000+",
    yearsExperience: "15+",
    destinationsCount: "25+",
    satisfactionRate: "98%"
  }
};

export default fr;
